export class HttpError<T = unknown> extends Error {
  override readonly name = 'HttpError';
  readonly status: number;
  readonly statusText: string;
  readonly url: string;
  readonly data: T | null;

  constructor(params: { status: number; statusText: string; url: string; data: T | null; message?: string }) {
    super(params.message ?? `HTTP ${params.status} ${params.statusText}`);
    this.status = params.status;
    this.statusText = params.statusText;
    this.url = params.url;
    this.data = params.data;
  }

  get isUnauthorized() {
    return this.status === 401;
  }
  get isForbidden() {
    return this.status === 403;
  }
  get isNotFound() {
    return this.status === 404;
  }
  get isServerError() {
    return this.status >= 500;
  }
  get isClientError() {
    return this.status >= 400 && this.status < 500;
  }
}

export class NetworkError extends Error {
  override readonly name = 'NetworkError';
  readonly cause: unknown;
  constructor(message: string, cause: unknown) {
    super(message);
    this.cause = cause;
  }
}
